import React, { useState, useEffect, useRef } from "react";
import Cookies from 'js-cookie';
import { useSpring, animated } from '@react-spring/web';

import Button from "./Button";
import CloseButton from "./CloseButton";
import VideoPlayer from "./VideoPlayer";

export default function Body({ 
    setShouldAnimate, 
    setStartExperience, 
    data, 
    shouldAnimate, 
    startExperience, 
    stationVisible,
    setStationVisible,
    setModelPosition,
    setVideoSrc,
    videoSrc,
    setIsTransitioning,
    isTransitioning,
    videoVisible
}) {
    const [isVideoReady, setIsVideoReady] = useState(false);
    const [isInitialView, setIsInitialView] = useState(true);
    const videoRef = useRef(null);
    const hasLoggedFirstStation = useRef(false);

    const welcomeTextSpring = useSpring({
        opacity: !shouldAnimate ? 1 : 0,
        transform: !shouldAnimate ? 'translate(0%, -50%)' : 'translate(100%, -50%)',
        delay: !shouldAnimate ? 1000 : 0,
    });

    const logStationView = async (stationIndex) => {
        const email = Cookies.get('userEmail');
        const stationName = data.stations[stationIndex].title;
        const apiUrl = `https://vwt-api.pfizer-qr.com/api/?e=${encodeURIComponent(email)}&c=website&a=click&l=${encodeURIComponent(stationName)}&v=nav`;
        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            console.log('Station view logged successfully');
        } catch (error) {
            console.error('Error logging station view:', error);
        }
    };

    const handleStationChange = async (direction) => {
        if (isTransitioning) return;

        setIsInitialView(false);

        let newStationIndex;
        if (direction === 'next') {
            newStationIndex = (stationVisible + 1) % data.stations.length;
        } else {
            newStationIndex = (stationVisible - 1 + data.stations.length) % data.stations.length;
        }
        
        setStationVisible(newStationIndex);
        setIsTransitioning(true);

        await logStationView(newStationIndex);
    };

    useEffect(() => {
        if (startExperience && !hasLoggedFirstStation.current) {
            logStationView(0);
            hasLoggedFirstStation.current = true;
        }
    }, [startExperience]);

    useEffect(() => {
        let playTimeout;
        if (isVideoReady && videoVisible && videoRef.current) {
            playTimeout = setTimeout(() => {
                videoRef.current.play().catch(error => {
                    console.error("Autoplay failed:", error);
                });
            }, 1000);
        }
    
        return () => {
            if (playTimeout) {
                clearTimeout(playTimeout);
            }
        };
    }, [isVideoReady, videoVisible]);

    return (
        <div className="body">
            {!shouldAnimate && (
                <animated.div style={welcomeTextSpring} className="content-window">
                    <div className="introContent">
                        <h1 className="tomorrow-bold" style={{marginBottom: '2rem'}}>{data.intro_title}</h1>
                        <p className="diatype-light mb-6" dangerouslySetInnerHTML={{ __html: data.intro_copy }}></p>
                        <Button setShouldAnimate={setShouldAnimate} setModelPosition={setModelPosition} text="Enter" />
                    </div>
                </animated.div>
            )}
            {shouldAnimate && !startExperience && (
                <div 
                    className="video-player-wrapper"
                    style={{ 
                        opacity: videoVisible ? 1 : 0, 
                        transition: 'opacity 1s',
                        visibility: videoVisible ? 'visible' : 'hidden'
                    }}
                >
                    <div 
                        className="introVideoContent" 
                        style={{ 
                            opacity: videoVisible ? 1 : 0, 
                            transition: 'opacity 1s',
                            visibility: videoVisible ? 'visible' : 'hidden'
                        }}
                    >
                        <CloseButton 
                            setStartExperience={setStartExperience} 
                            startExperience={startExperience} 
                            setVideoSrc={setVideoSrc}
                        />
                        <VideoPlayer 
                            ref={videoRef} 
                            src="https://pfizer-vwt.s3-accelerate.amazonaws.com/assets/intro-video.mp4" 
                            autoplay={videoVisible && isVideoReady}
                            onCanPlay={() => setIsVideoReady(true)}
                        />
                    </div>
                </div>
            )}
            {startExperience && data.stations && (
                <div className="experienceContent">
                    {(!isInitialView || stationVisible !== 0) && (
                        <button 
                            onClick={() => handleStationChange('prev')} 
                            className={`switchStation prevStation ${isTransitioning ? 'disabled' : ''}`}
                            disabled={isTransitioning}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill={isTransitioning ? "gray" : "white"} viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                            </svg>
                        </button>
                    )}
                    <button 
                        onClick={() => handleStationChange('next')} 
                        className={`switchStation nextStation ${isTransitioning ? 'disabled' : ''}`}
                        disabled={isTransitioning}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill={isTransitioning ? "gray" : "white"} viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                        </svg>
                    </button>
                </div>
            )}
        </div>
    )
}